export enum ModalID {
  AddCondition = 'AddCondition',
  Confirm = 'Confirm',
  MIRenderModal = 'MIRenderModal',
  TeethNumberingModal = 'TeethNumberingModal',
  MPRFullScreenModal = 'MPRFullScreenModal',
  UploadStudy_DEPRECATED = 'UploadStudy',
  OrderReport = 'OrderReport',
  SharePatient = 'SharePatient',
  ProtectedSharing = 'ProtectedSharing',
  EditInfoModal = 'EditInfoModal',
  PermissionsModal = 'PermissionsModal',
  AddStaffModal = 'AddStaffModal',
  EditCompanyInfoModal = 'EditCompanyInfoModal',
  GetFullAccessModal = 'GetFullAccessModal',
  CongratsModal = 'CongratsModal',
  NewAccountModal = 'NewAccountModal',
  RevokeSharedPatientModal = 'RevokeSharedPatientModal',
  Order3DSegmentronModal = 'Order3DSegmentronModal',
  OrderOrthoORImplantModal = 'OrderOrthoORImplantModal',
  BillingInformationModal = 'BillingInformationModal',
  CancelSubscriptionModal = 'CancelSubscriptionModal',
  ResetPasswordErrorModal = 'ResetPasswordErrorModal',
  PatientRemovalConfirmationModal = 'PatientRemovalConfirmationModal',
  PatientModalForm = 'PatientModalForm',
  DiagnocoinHistoryModal = 'DiagnocoinHistoryModal',
  PauseOrActivateSubscriptionModal = 'PauseOrActivateSubscriptionModal',
  AboutLabelingModal = 'AboutLabelingModal',
  ReportInfo = 'ReportInfo',
  DentalPhotosUpload = 'DentalPhotosUpload',
  EditAlbumModal = 'EditAlbumModal',
  DentalPhotoSlider = 'DentalPhotoSlider',
  MobileOrderReportModal = 'MobileOrderReportModal',
  TreatingDoctorsModal = 'TreatingDoctorsModal',
  TreatingDoctorsFilterDrawer = 'TreatingDoctorsFilterDrawer',
  TreatingDoctorsSelectDrawer = 'TreatingDoctorsSelectDrawer',
  HeaderDrawer = 'HeaderDrawer',
  AllSharedWith = 'AllSharedWith',
  ClinicalCaseDescriptionEditorModal = 'ClinicalCaseDescriptionEditorModal',
  TranscriptorRecording = 'TranscriptorRecording',
  TranscriptorContinueRecording = 'TranscriptorContinueRecording',
  FDADentalProfessionalConfirmationModal = 'FDADentalProfessionalConfirmationModal',
  RawMeshViewerInfo = 'RawMeshViewerInfo',
  MobileDentalPhotoUploadMenu = 'MobileDentalPhotoUploadMenu',
}
